import { graphql, commitMutation, type Environment } from 'react-relay/legacy';
import {
    type commitFollowSearchMutation,
    type commitFollowSearchMutation$data,
    type FavoritePageInput,
} from './__generated__/commitFollowSearchMutation.graphql';

const mutation = graphql`
    mutation commitFollowSearchMutation($followSearchUriRef: String, $input: FavoritePageInput!) {
        favoritePage(input: $input) {
            user {
                favorites(first: 1, types: [SEARCH], pages: [$followSearchUriRef]) {
                    edges {
                        node {
                            serviceId
                        }
                    }
                }
            }
        }
    }
`;

type InputArgs = {
    userId: string;
    followSearchId: string | null | undefined;
    followSearchDisplayName: string;
    followSearchUriRef: string;
    onCompleted: (response: commitFollowSearchMutation$data) => void;
    onError: () => void;
};

export function commitFollowSearch(
    environment: Environment,
    {
        userId,
        followSearchId,
        followSearchDisplayName,
        followSearchUriRef,
        onCompleted = () => {},
        onError = () => {},
    }: InputArgs
): void {
    const type = 'SEARCH';
    const input: FavoritePageInput = {
        page: followSearchUriRef,
        type,
        name: followSearchDisplayName,
        userId,
        favoriteId: followSearchId,
        action: followSearchId ? 'REMOVE' : 'ADD',
    };

    commitMutation<commitFollowSearchMutation>(environment, {
        mutation,
        variables: {
            input,
            followSearchUriRef,
        },
        onCompleted,
        onError,
    });
}
